import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import jsPDF from 'jspdf'
import uuidv4 from 'uuid/v4'
import Input from '../components/Input'
import ScrollBar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import { AlertModal } from 'components/ModalTypes'
import * as userActions from '../store/actions/user'
import axios from 'axios'
import FileSaver from 'file-saver'
import Loading from '../components/Loading'
import classnames from 'classnames'
import authCodeTextImg from '../static/img/auth-code-text.png'
import ConsentLegalText from '../components/ConsentLegalText'


const API_URL = process.env.REACT_APP_API_URL

class LegacyConsent extends Component {
    state = {
      step: 1,
      consent: null,
      authCode: '',
      genAuthCode: uuidv4(),
      cancelModal: false,
      cancelled: false,
      loading: false,
      e_consent_settings: false,
    }

    componentDidMount() {
      const { response } = this.props
      if (response) {
        this.setState({
          step: response.step,
          e_consent_settings: response.e_consent_settings,
        })
      }
    }

    downloadFile = (url) => {
      const fullUrl = `${API_URL}${url}`
      this.setState({ loading: true })
      axios({
        method: 'GET',
        url: fullUrl,
        responseType: 'blob', // important
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'appraisal_report.pdf')
        this.setState({ loading: false, step: 3 })
      })
    }

    onConsent = () => {
      const {
        consent,
      } = this.state
      const {
        match: {
          params: {
            token,
          },
        },
        userActions,
      } = this.props

      if (!consent) {
        return this.setState({ cancelModal: true })
      }
      userActions.userConsent(token)
        .then(_ => this.setState({ step: 2 }))
        .catch(error => console.log(error))
    }

    onRadioChange = ({ target: { value } }) => this.setState({ consent: (/true/i).test(value) })

    onAuthCodeChange = (authCode) => this.setState({ authCode: authCode.trim() })

    onCancel = () => {
      const {
        match: {
          params: {
            token,
          },
        },
        userActions,
      } = this.props

      userActions.denyConsent(token)
        .then(_ => this.setState({ cancelled: true, cancelModal: false }))
    }

    downloadPDF = () => {
      const {
        genAuthCode,
      } = this.state

      const img = new Image()
      img.src = authCodeTextImg
      img.onload = function() {
        // eslint-disable-next-line new-cap
        const pdf = new jsPDF()

        pdf.addImage(img, 'PNG', 20, 40, 129, 43)
        pdf.text(20, 90, `\t${genAuthCode}`)
        // save the PDF document (downloadable)
        pdf.save()
      }
    }

    render = () => {
      const {
        step,
        consent,
        authCode,
        genAuthCode,
        cancelModal,
        cancelled,
        e_consent_settings: eConsentSettings,
      } = this.state
      const {
        match: {
          params: {
            token,
          },
        },
      } = this.props

      if (cancelled) {
        return (
                <div>
                    <div className="container text-center">
                        <div className="success">
                            <div className="icon icon-cell animate">done</div>
                        </div>
                        <h1>Electronic Delivery Denied</h1>
                        <p className="info">
                            Your lender will be notified<br/>
                            Your appraisal will be sent to you in the Mail
                        </p>
                        <p className="info">To restart the process click the button below.</p>
                        <button className="button" onClick={() => this.setState({ step: 1, cancelled: false })}>
                            Return to Electronic Consent Form
                        </button>
                    </div>
                </div>
        )
      }

      const isValidAuthCode = authCode === genAuthCode

      return (
            <div>
                <div className="container text-center">
                    {cancelModal && (
                        <AlertModal
                            closeText="No"
                            submitText="Yes"
                            onClose={() => this.setState({ cancelModal: false })}
                            onSubmit={this.onCancel}
                        >
                            <div>Are you sure you want to deny Electronic Delivery?</div>
                        </AlertModal>
                    )}
                    {this.state.loading && <Loading/>}
                    {step === 0 && (
                        <div className="box bg">
                            <h1>This link was sent in error.</h1>
                            <p>Please disregard the email.</p>
                        </div>
                    )}

                    {step === 1 && (
                        <div className="box bg">
                            <h1>Acknowledge Electronic Delivery</h1>
                            <ScrollBar className="scrollable-text">
                                <ConsentLegalText/>
                            </ScrollBar>
                            <form className="radio-form">
                                <div className="radio-line">
                                    <input
                                        className="radio"
                                        type="radio"
                                        name="consent"
                                        value={true}
                                        onChange={this.onRadioChange}
                                        data-testid="consent-yes-radio"
                                    />
                                    <span>
                        I consent to receive the appraisal report in electronic
                        form
                      </span>
                                </div>
                                <div className="radio-line">
                                    <input
                                        className="radio"
                                        type="radio"
                                        name="consent"
                                        value={false}
                                        onChange={this.onRadioChange}
                                        data-testid="consent-no-radio"
                                    />
                                    <span>
                        I decline to receive the appraisal report electronically
                      </span>
                                </div>
                            </form>
                            <div>
                                <button
                                    className="button no-transform error"
                                    onClick={() => this.setState({ cancelModal: true })}
                                >
                                    Deny
                                </button>
                                <button
                                    disabled={consent === null}
                                    className={'button' + (consent === null ? '-disabled' : '')}
                                    onClick={this.onConsent}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>
                    )}
                    {step === 2 && (
                        <div className="box bg">
                            <h1>Download Your Appraisal</h1>
                            <p className="info">
                                Complete the steps below to download your appraisal.
                            </p>
                            <p className="body-text">
                                Step 1*: Download the test PDF to obtain your security code.
                            </p>
                            <button className="button no-transform" onClick={this.downloadPDF}>
                                Download Test PDF
                            </button>
                            <p className="body-text">
                                Step 2*: Enter the security code below.
                            </p>
                            <Input
                                input={{ type: 'text', placeholder: 'Enter Auth Code' }}
                                onChange={this.onAuthCodeChange}
                                field="authCode"
                                value={authCode}
                            />
                            <p className="body-text">
                                Step 3*: You are all set! Download your appraisal by clicking
                                the button below.{' '}
                            </p>
                            <button
                                disabled={!isValidAuthCode}
                                className={classnames(
                                  'no-transform',
                                  {
                                    button: isValidAuthCode,
                                    'button-disabled': !isValidAuthCode,
                                  }
                                )}
                                onClick={() =>
                                  this.downloadFile(`/order/submission/${token}`)
                                }
                            >
                                Download Appraisal
                            </button>
                            {eConsentSettings && <div>
                                <p className="body-text">
                                    If you do not wish to grant consent, you may deny consent.
                                </p>
                                <button
                                    className="button no-transform error"
                                    onClick={() => this.setState({ cancelModal: true })}
                                >
                                    Deny
                                </button>
                            </div>}

                            <div className="requirement-text-container">
                                <p className="caption">
                                    *Required to successfully download appraisal
                                </p>
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="container">
                            <div className="success">
                                <div className="icon icon-cell animate">done</div>
                            </div>
                            <h1>Appraisal Downloaded!</h1>
                            <p className="info">
                                Your appraisal has been successfully downloaded
                                <br/>
                                Thank you for using Reggora
                            </p>
                        </div>
                    )}
                    {step === 4 && (
                        <div className="box bg">
                            <h1>Welcome Back!</h1>
                            <p className="info">
                                You have already downloaded your appraisal
                                <br/>
                                But you can download it again by clicking the button below
                            </p>
                            <button
                                className="button"
                                onClick={() =>
                                  this.downloadFile(`/order/submission/${token}`)
                                }
                            >
                                Download Appraisal
                            </button>
                        </div>
                    )}
                    {step === 5 && (
                        <div className="box bg">
                            <h1>Welcome Back!</h1>
                            <p className="info">
                                You denied to electronically download your appraisal
                                <br/>
                                But you can change your mind at any time.
                            </p>
                            <p className="info">
                                To restart the process click the button below.
                            </p>
                            <button
                                className="button"
                                onClick={() => this.setState({ step: 1 })}
                            >
                                Return to Electronic Consent Form
                            </button>
                        </div>
                    )}
                </div>
            </div>
      )
    }
}

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch),
})

export default connect(null, mapDispatchToProps)(LegacyConsent)
